import Vuex from 'vuex'

// 把模块名称的首字母写成大写 【谢谢】
import CommonModule from './modules/common' // 公共模块
import SearchResultModule from './modules/searchResult' // 公共模块

// 引用所有的模块
const models = {
  CommonModule,
  SearchResultModule
}

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ...models
  }
})